import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import SiteVisitList from "../SiteVisit/siteVisitList";
import AgentSiteVisitList from "../SiteVisit/agentSiteVisit";
import "./headerSiteVisit.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "site_visit_header_tab";

const HeaderSiteVisit = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "user_site_visit"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "user_site_visit" ? "clicked" : ""}
              onClick={() => handleTableSelection("user_site_visit")}
            >
              User Site List
            </h4>

            <h4
              className={selectedTable === "agent_site_visit" ? "clicked" : ""}
              onClick={() => handleTableSelection("agent_site_visit")}
            >
              Agent Site Visit
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "user_site_visit" ? "block" : "none" }}>
            <SiteVisitList />
          </div>

          <div style={{ display: selectedTable === "agent_site_visit" ? "block" : "none" }}>
            <AgentSiteVisitList />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderSiteVisit;
